import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { dictionarySchema } from '@zaoblako/shared/modules/serde/schemas/dictionary.schema';

import * as yup from 'yup';

/** Analytics for the previous three months for the budget request item */
export interface BudgetRequestItemAnalyticsInterface {
  /** Total amount value for all three months */
  totalAmount: number;
  /** Account balance amount () */
  accountBalanceAmount?: number;
  /** Total amount value for each month (dictionary object where key is date in `YYYY-MM-DD` format and value is amount value) */
  monthAmount: Record<string, number>;
}

/** Analytics for the previous three months for the budget request item - DTO schema */
export const BudgetRequestItemAnalyticsDto = SerdeDtoClass.create<BudgetRequestItemAnalyticsInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_ANALYTICS_DTO, {
  totalAmount: {
    label: 'Общая сумма',
    serializer: yup.number(),
  },
  accountBalanceAmount: {
    optional: true,
    label: 'Остатки на счетах',
    serializer: yup.number(),
  },
  monthAmount: {
    label: 'Сумма по месяцам',
    serializer: dictionarySchema(yup.number()),
  },
});
